import React, { useState } from 'react';
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Input,
  Button,
} from '@material-tailwind/react';

interface Props {
  reason?: string;
  onConfirm: (password: string) => void;
  onCancel: () => void;
}

const PasswordModal: React.FC<Props> = ({ reason, onConfirm, onCancel }) => {
  const [password, setPassword] = useState('');

  return (
    <Dialog
      open={true}
      handler={onCancel}
      placeholder={undefined}
      onResize={undefined}
      onResizeCapture={undefined}
      onPointerEnterCapture={undefined}
      onPointerLeaveCapture={undefined}
      className={'bg-[var(--card)] text-[var(--text)]'}
    >
      <DialogHeader
        placeholder={undefined}
        onResize={undefined}
        onResizeCapture={undefined}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
        className={'text-[var(--text)]'}
      >
        Potwierdź hasłem
      </DialogHeader>
      <DialogBody
        placeholder={undefined}
        onResize={undefined}
        onResizeCapture={undefined}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
        className={'text-[var(--text)]'}
      >
        <p className="mb-4 text-sm ">{reason || 'Ta akcja wymaga potwierdzenia hasłem.'}</p>
        <Input
          placeholder={undefined}
          onResize={undefined}
          onResizeCapture={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
          crossOrigin={undefined}
          type="password"
          label="Hasło"
          value={password}
          onChange={e => setPassword(e.target.value)}
          className={'text-[var(--text)]'}
        />
      </DialogBody>
      <DialogFooter
        placeholder={undefined}
        onResize={undefined}
        onResizeCapture={undefined}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
      >
        <Button
          placeholder={undefined}
          onResize={undefined}
          onResizeCapture={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
          variant="text"
          color="red"
          onClick={onCancel}
          className="mr-2"
        >
          Anuluj
        </Button>
        <Button
          placeholder={undefined}
          onResize={undefined}
          onResizeCapture={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
          variant="gradient"
          color="blue"
          onClick={() => onConfirm(password)}
          disabled={!password}
        >
          Potwierdź
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export default PasswordModal;
